import React from 'react';

import { SiteContext } from '@/contexts/site-context';

import { useRouter } from 'next/router';

import InputMask from 'react-input-mask';

import FormSteps from '@/components/FormSteps';

import PhoneIcon from 'svgs/phone.svg';

const ContactInfo = () => {
  const [site, setSite] = React.useContext(SiteContext);

  const [contactPhone, setContactPhone] = React.useState('');
  const [errors, setErrors] = React.useState({});
  const [isReady, setIsReady] = React.useState(false);

  const router = useRouter();

  const handleSubmit = () => {
    if (isValid()) {
      setSite({
        ...site,
        business_sign_up: {
          ...site.business_sign_up,
          contact_phone: contactPhone
        }
      });

      router.push('/signup/summary');
    }
  };

  const isValid = () => {
    let isValid = true;
    const errors = {};

    if (!contactPhone || contactPhone.trim().length === 0) {
      isValid = false;
      errors.contactPhone = true;
    }

    setErrors({
      ...errors
    });

    return isValid;
  };

  React.useEffect(() => {
    if (!site.business_sign_up?.budget) {
      router.push('/signup/budget');
    } else {
      setContactPhone(site.business_sign_up.contact_phone || site.business_sign_up.business_phone);
      setIsReady(true);
    }
  }, [site.business_sign_up.contact_phone]);

  return (
    <div className="signup-form-container">
      {isReady && (
        <div className="signup-form-wrapper">
          <FormSteps stepIndex={4} totalSteps={6} />
          <fieldset>
            <h2>Lead Contact</h2>
            <h3>Confirm the phone number you would like customers to reach you on.</h3>
            <div className="row phone-container">
              <div className={`input-container phone contact ${errors.contactPhone ? 'error' : ''}`}>
                <PhoneIcon />
                <InputMask
                  mask="(999) 999-9999"
                  type="tel"
                  placeholder="Phone"
                  value={contactPhone || ''}
                  onChange={(e) => {
                    setContactPhone(e.target.value);
                    setErrors({});
                  }}
                />
                <div className="error_msg">Required</div>
              </div>
            </div>
            <div className="row next-container">
              <div className="actions">
                <button className="next button" onClick={() => handleSubmit()}>
                  Next
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      )}
    </div>
  );
};

export default ContactInfo;
